import type { FC } from "react";
import { useEffect, useState } from "react";

import { type Geography } from "src/api/sure-api/geography/geographySchema";
import { useGetOneGeography } from "src/api/sure-api/geography/useGetOneGeography";

import { GeographyAutocomplete } from "./GeographyAutocomplete";

interface FormGeographySelectorProps {
    value: string | null | undefined;
    onChange: (code: string | null) => void;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
    sx?: object;
}

export const FormGeographySelector: FC<FormGeographySelectorProps> = ({
    value,
    onChange,
    disabled = false,
    error = false,
    helperText,
    sx,
}) => {
    const normalizedCode = value?.trim() ?? "";
    const [pickedGeography, setPickedGeography] = useState<Geography | null>(null);

    const { geography: fetchedGeography } = useGetOneGeography(normalizedCode, {
        enabled: normalizedCode !== "",
    });

    useEffect(() => {
        if (normalizedCode === "") {
            setPickedGeography(null);
            return;
        }

        if (pickedGeography !== null && pickedGeography.code !== normalizedCode) {
            setPickedGeography(null);
        }
    }, [normalizedCode, pickedGeography]);

    const selectedGeography = fetchedGeography ?? (pickedGeography?.code === normalizedCode ? pickedGeography : null);

    return (
        <GeographyAutocomplete
            value={selectedGeography}
            onChange={(geography) => {
                setPickedGeography(geography);
                onChange(geography?.code ?? null);
            }}
            disabled={disabled}
            error={error}
            helperText={helperText}
            sx={sx}
        />
    );
};
